// extracted by mini-css-extract-plugin
export default {"aepiDisclaimer":"freeform-page-module--aepiDisclaimer--8cf18","aepi-disclaimer":"freeform-page-module--aepi-disclaimer--2f561"};